import { render } from "./SaveButton.vue?vue&type=template&id=7f85b4b0&scoped=true"
import script from "./SaveButton.vue?vue&type=script&lang=js"
export * from "./SaveButton.vue?vue&type=script&lang=js"

import "./SaveButton.vue?vue&type=style&index=0&id=7f85b4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f85b4b0"]])

export default __exports__